'use strict';

exports.__esModule = true;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getCurrent = getCurrent;
exports.updateState = updateState;
exports.getWaypoints = getWaypoints;
exports.ackCancellation = ackCancellation;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// temporarily use /quiqee namespace until we migrate
var API = {
  COURIER_MISSIONS: '/quiqee/missions',
  COURIER_MISSIONS_EVENTS: function COURIER_MISSIONS_EVENTS(missionId) {
    return '/quiqee/missions/' + missionId + '/events';
  },
  COURIER_MISSIONS_WAYPOINTS: function COURIER_MISSIONS_WAYPOINTS(missionId) {
    return '/quiqee/missions/' + missionId + '/waypoints';
  },
  COURIER_MISSIONS_CANCELLATION_ACK: function COURIER_MISSIONS_CANCELLATION_ACK(missionId) {
    return '/quiqee/missions/' + missionId + '/cancellation_acknowledgements';
  }

  /**
   * Wrapper for `/quiqee/missions` API endpoint
   */

};var missions = {
  getCurrent: getCurrent,
  updateState: updateState,
  getWaypoints: getWaypoints,
  ackCancellation: ackCancellation
};

exports.default = missions;

/**
 * Get current missions for quiqee
 * @param {Object} attrs - Attributes
 * @returns {promise} containing missions
 */

function getCurrent(attrs) {
  return _apiClient2.default.get({ route: API.COURIER_MISSIONS, params: (0, _extends3.default)({}, attrs, { current: true }) });
}

/**
 * Update mission state
 * @param {Object} params.missionId - The id of the mission
 * @param {Object} params.event - The state the attempt transition to (start, complete, ...)
 * @returns {promise} with response/errors
 */
function updateState(params) {
  return _apiClient2.default.post({ route: API.COURIER_MISSIONS_EVENTS(params.missionId), data: params });
}

/**
 * Get waypoints
 * @param {Object} params.missionId - The id of the mission
 * @returns {promise} with response/errors
 */
function getWaypoints(_ref) {
  var missionId = _ref.missionId,
      params = (0, _objectWithoutProperties3.default)(_ref, ['missionId']);

  return _apiClient2.default.get({ route: API.COURIER_MISSIONS_WAYPOINTS(missionId), params: params });
}

/**
 * Acknowledge mission cancellation
 * @param {Object} params.missionId - The id of the mission
 * @returns {promise} with response/errors
 */
function ackCancellation(params) {
  return _apiClient2.default.post({ route: API.COURIER_MISSIONS_CANCELLATION_ACK(params.missionId), data: params });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/courier/missions/missions.js
// module id = 1187
// module chunks = 0